import InvitePatientButton from "./InvitePatientButton"

export default InvitePatientButton;